import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { services, values, fullServices, images } from "@/mock";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: "easeOut", delay: i * 0.1 },
  }),
};

export const Services = () => {
  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="relative bg-[#0A0A0A] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="max-w-2xl"
        >
          <p className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Shërbimet Tona
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F5F5F5] tracking-tight">
            Mbështetje e plotë, me dinjitet
          </h2>
          <p className="mt-5 text-base text-gray-400 leading-relaxed">
            Ofrojmë një shërbim të plotë që shoqëron familjen në çdo fazë, që
            nga momenti i parë deri në lamtumirën e fundit.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="group bg-[#1A1A1A] border border-[#D4AF37]/20 rounded-2xl p-8 hover:border-[#D4AF37]/60 transition-colors duration-500"
              >
                <span className="inline-flex h-14 w-14 items-center justify-center rounded-full border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-colors duration-500">
                  <Icon size={26} strokeWidth={1.5} />
                </span>
                <h3 className="mt-6 font-serif text-2xl text-[#F5F5F5]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                  {s.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Fascia immagini + valori */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="grid grid-cols-2 gap-6">
            {[images.service1, images.service2].map((img, idx) => (
              <div
                key={idx}
                className="overflow-hidden rounded-2xl border border-[#D4AF37]/20 h-64 lg:h-full"
              >
                <img
                  src={img}
                  alt="Shërbim funebër"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            ))}
          </div>

          <div className="flex flex-col justify-center gap-8">
            {values.map((v, i) => {
              const Icon = v.icon;
              return (
                <motion.div
                  key={i}
                  variants={fadeUp}
                  custom={i}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.3 }}
                  className="flex gap-5"
                >
                  <span className="flex-shrink-0 h-12 w-12 rounded-full bg-[#1A1A1A] border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37]">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <div>
                    <h4 className="font-serif text-xl text-[#F5F5F5]">
                      {v.title}
                    </h4>
                    <p className="mt-1 text-sm text-gray-400 leading-relaxed">
                      {v.description}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        {/* Lista e plotë e shërbimeve */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="mt-20 bg-[#111111] border border-[#D4AF37]/20 rounded-2xl p-8 lg:p-12"
        >
          <h3 className="font-serif text-2xl sm:text-3xl text-[#F5F5F5] mb-8">
            Të gjitha shërbimet tona
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4">
            {fullServices.map((item, i) => (
              <div
                key={i}
                data-testid={`full-service-${i}`}
                className="flex items-start gap-3"
              >
                <span className="flex-shrink-0 mt-0.5 text-[#D4AF37]">
                  <Check size={18} strokeWidth={2} />
                </span>
                <span className="text-sm text-gray-300 leading-relaxed">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
